import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { Modal, Close, Header } from "MODULES/shared/components/Modal";
import { toastr } from "react-redux-toastr";
import Form from "./Form";

export default function CoreReturnCostSavings({
  open,
  close,
  lineItem,
  reload
}) {
  if (Number(get(lineItem, "repaired_line_item.part_cost")) === 0 && open) {
    toastr.error(
      "Error",
      "Parts Cost in the Higher Assembly is required to apply Core Return Cost Savings."
    );

    close();
  }

  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Core Return Cost Savings</h4>
      </Header>
      <Form
        close={close}
        reload={reload}
        lineItem={lineItem}
        enableReinitialize
      />
    </Modal>
  );
}

CoreReturnCostSavings.propTypes = {
  open: T.bool.isRequired,
  close: T.func.isRequired,
  reload: T.func.isRequired,
  lineItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/CoreReturnCostSavings/CoreReturnCostSavingsModal.jsx